var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-index"},[(_vm.role == 'purchase')?_c('Purchase'):_vm._e(),(_vm.role == 'supplier')?_c('SearchHome'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }